import { render, staticRenderFns } from "./talkBubble.vue?vue&type=template&id=6dd20a59&scoped=true&"
import script from "./talkBubble.vue?vue&type=script&lang=js&"
export * from "./talkBubble.vue?vue&type=script&lang=js&"
import style0 from "./talkBubble.vue?vue&type=style&index=0&id=6dd20a59&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd20a59",
  null
  
)

export default component.exports